import SintegraForm from '@/components/Fiscal/SintegraForm';
import { TabContentWrapper } from '@/components/_common';
import { useCompanySintegraGenerate } from '@/core/domain/sintegra/Sintegra.hooks';
import {
  CompanySintegraGenerateFormValues,
  invoiceTypeSintegra,
} from '@/core/domain/sintegra/Sintegra.types';
import { PageProps } from '@/types/PageProps';
import { DateTimeFormat } from '@/utils/moment';
import { Button, Form } from 'antd';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

const SintegraPage = ({ route }: PageProps) => {
  const intl = useIntl().formatMessage;

  const [form] = Form.useForm<CompanySintegraGenerateFormValues>();

  const { mutateAsync, isLoading } = useCompanySintegraGenerate();

  const donwloadTxt = (text: string) => {
    const blob = new Blob([text], { type: 'text/plain' });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', 'Sintegra.txt');

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSubimit = async () => {
    const formValues = await form.validateFields();

    const invoiceType =
      String(formValues.invoiceType) === invoiceTypeSintegra.ALL
        ? [invoiceTypeSintegra.NFE, invoiceTypeSintegra.NFS]
        : [formValues.invoiceType];

    const response = await mutateAsync({
      ...formValues,
      startDate: moment(formValues.startDate).format(DateTimeFormat),
      endDate: moment(formValues.endDate).format(DateTimeFormat),
      inventoryDate: moment(formValues.inventoryDate).format(DateTimeFormat),
      invoiceType: invoiceType,
    });

    donwloadTxt(response);
  };

  return (
    <>
      <Helmet title={intl({ id: route.name })} />

      <TabContentWrapper
        permissions={route.permissions}
        title={route.name}
        extra={
          <Button
            block
            onClick={handleSubimit}
            loading={isLoading}
            type="primary"
          >
            Gerar Arquivo
          </Button>
        }
      >
        <SintegraForm form={form} />
      </TabContentWrapper>
    </>
  );
};

export default SintegraPage;
